import { render, staticRenderFns } from "./addReportRules.vue?vue&type=template&id=87a6c156"
import script from "./addReportRules.vue?vue&type=script&lang=js"
export * from "./addReportRules.vue?vue&type=script&lang=js"
import style0 from "./addReportRules.vue?vue&type=style&index=0&id=87a6c156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports